<mat-form-field appearance="outline" class="w-100">
  <mat-label>{{ 'location' | translate }}</mat-label>

  <mat-select [placeholder]="'advert_location_placeholder' | translate"
              [formControl]="formControl"
              (selectionChange)="onChange($event.source.value)"
              [compareWith]="compareLocations">

    <mat-option>
      <ngx-mat-select-search [formControl]="searchControl"
                             [placeholderLabel]="'searching' | translate"
                             [searching]="loading"
                             [clearSearchInput]="false">
        <app-icon ngxMatSelectSearchClear>close</app-icon>
        <mat-option ngxMatSelectNoEntriesFound disabled>
          {{ 'nothing_found' | translate }}
        </mat-option>
      </ngx-mat-select-search>
    </mat-option>

    @if (selectedLocation) {
      <mat-select-trigger>
        {{ [selectedLocation.city_name, selectedLocation.district_name, selectedLocation.region_name].filter(Boolean).join(', ') }}
      </mat-select-trigger>
    }

    @for (item of filteredLocations; track $index) {
      <mat-option [value]="{ city_id: item.city_id, district_id: item.district_id}">
        <div class="dropdown-v2-option-title">
          {{ [item.city_name, item.district_name].filter(Boolean).join(', ') }}
        </div>
        <div class="dropdown-v2-option-subtitle">
          {{ item.region_name }}
        </div>
      </mat-option>
    }

    @if (!(filteredLocations && filteredLocations.length) && searchControl.getRawValue()!.length >= 2 && !loading) {
      <mat-option disabled>
        {{ 'nothing_found' | translate }}
      </mat-option>
    }
  </mat-select>

  @if (formControl.touched && formControl.invalid) {
    <mat-error>
      @if (formControl.errors?.['required']) {
        {{ 'input_errors.required' | translate }}
      }
    </mat-error>
  }
</mat-form-field>
